module.exports = __webpack_public_path__ + "img/tick.d1cee8e4.png";